import { render, staticRenderFns } from "./ManageProviderImportV2.vue?vue&type=template&id=036826ef&scoped=true"
import script from "./ManageProviderImportV2.vue?vue&type=script&lang=js"
export * from "./ManageProviderImportV2.vue?vue&type=script&lang=js"
import style0 from "./ManageProviderImportV2.vue?vue&type=style&index=0&id=036826ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036826ef",
  null
  
)

export default component.exports